<template>
  <section class="section section-shaped section-lg my-0">
    <div class="shape shape-style-1 bg-gradient-default">
      <span></span>
      <span></span>
      <span></span>
      <span></span>
      <span></span>
      <span></span>
      <span></span>
      <span></span>
    </div>
    <div class="container pt-lg-md">
      <div class="row justify-content-center">
        <div class="col-lg-5">
          <card type="secondary" shadow
                header-classes="bg-white pb-5"
                body-classes="px-lg-5 py-lg-5"
                class="border-0">
            <template>
              <div v-if="login_errado" class="alert alert-danger" role="alert">
                Número de inscrição ou CPF inválido.
              </div>
              <div class="text-muted text-center mb-3">
                <small>Entre com:</small>
              </div>
              <div class="btn-wrapper text-center">
              </div>
            </template>
            <template>
              <form @submit.prevent="envia_login" role="form">
                <base-input v-model="username" alternative
                            class="mb-3"
                            v-mask="'#######-#'"
                            placeholder="Número de inscrição"
                            addon-left-icon="ni ni-single-02">
                </base-input>
                <base-input v-mask="'###.###.###-##'" v-model="password" alternative

                            placeholder="CPF"
                            addon-left-icon="ni ni-badge">
                </base-input>

                <div class="text-center">
                  <base-button native-type="submit" type="primary" class="my-4">Entrar</base-button>
                </div>
              </form>
            </template>
          </card>
          <div class="row mt-3">
            <div class="col-6">
              <a href="#" class="text-light">
                <!--                <small>Esqueci minha senha</small>-->
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>
<script>
import axios from 'axios';
import {useRouter} from 'vue-router';
import Vue from 'vue'
import vueCrypt from 'vue-crypt'
import {cpf} from "cpf-cnpj-validator";

export default {
  name: 'Login',
  data() {
    return {
      username: '',
      password: '',
      login_errado: false,
      logins: [{cpf: 321., num_cand: 123}]
    }
  },
  methods: {
    envia_login: async function () {

const encryptedText = this.CryptoJS.AES.encrypt("Hi There!",  'secret key 123').toString()
const decryptedText = this.CryptoJS.AES.decrypt('U2FsdGVkX1+rGzJrqd1xvB4s0Sxxmcl9dbo4sUwcMsE=', 'secret key 123').toString(this.CryptoJS.enc.Utf8)

      const encrypt = (texto)=>{
        return this.CryptoJS.AES.encrypt(texto,  'yqKdRqWEAywufSJCZpvPUF5e929UKqMh5eh7AMP5Xpv2FrmdpFeSsnVkyTGvrhPRUG48tZtn32sEGz2R8tDrGcR6wTyYwhdCEvZxbdW42SYpKF7HvrW2XK6zjuWX9946tTx5RhycNDEW8uS475mRVNASZ4CW4v4RhBS5SYHCNHc6DjpwpzWcwuMvTQzCBzMtGbXF8ud4qXhcXnwAQ3xef2tQz3ZeBjvhu32zNGY5PXem92HX3MLRhuw78TqUVsUT').toString()
      }
      const decrypt = (texto)=>{
        return this.CryptoJS.AES.decrypt(texto,'yqKdRqWEAywufSJCZpvPUF5e929UKqMh5eh7AMP5Xpv2FrmdpFeSsnVkyTGvrhPRUG48tZtn32sEGz2R8tDrGcR6wTyYwhdCEvZxbdW42SYpKF7HvrW2XK6zjuWX9946tTx5RhycNDEW8uS475mRVNASZ4CW4v4RhBS5SYHCNHc6DjpwpzWcwuMvTQzCBzMtGbXF8ud4qXhcXnwAQ3xef2tQz3ZeBjvhu32zNGY5PXem92HX3MLRhuw78TqUVsUT').toString(this.CryptoJS.enc.Utf8);
      }

      const gera_file_name = (cpf,num_cand)=>{

        let candidato = {CPF:cpf,NUMEROINSC:num_cand}
        let cod_projeto = '2106_pt'
        let codigo_meio = candidato.CPF.replace(/\./g, '').replace('-','')*7919;
        codigo_meio=codigo_meio.toString()

        let codigo_arquivo = parseInt(codigo_meio.substring(0,5))*parseInt(candidato.NUMEROINSC.replace('-',''))*13 + '_'
        + String.fromCharCode(65 + parseInt(codigo_meio[3]))
        + String.fromCharCode(parseInt(codigo_meio[1]%2===0? 97 : 67)+ parseInt(codigo_meio[1]))
        + String.fromCharCode(parseInt(codigo_meio[4]%2===0? 97 : 67)+ parseInt(codigo_meio[5]))
        + String.fromCharCode(parseInt(codigo_meio[3]%2===0? 97 : 67)+ parseInt(codigo_meio[2]))
        + String.fromCharCode(parseInt(codigo_meio[7]%2===0? 97 : 67)+ parseInt(codigo_meio[7]))
        + '-'
        + String.fromCharCode(parseInt(codigo_meio[0]%2===0? 97 : 67)+ parseInt(codigo_meio[11]))
        + String.fromCharCode(parseInt(codigo_meio[1]%2===0? 97 : 67)+ parseInt(codigo_meio[9]))
        + String.fromCharCode(parseInt(codigo_meio[5]%2===0? 97 : 67)+ parseInt(codigo_meio[4]))
        + String.fromCharCode(parseInt(codigo_meio[8]%2===0? 97 : 67)+ parseInt(codigo_meio[5]))
        + String.fromCharCode(parseInt(codigo_meio[3]%2===0? 97 : 67)+ parseInt(codigo_meio[8]))
        + '_'
        + String.fromCharCode(parseInt(codigo_meio[2]%2===0? 97 : 67)+ parseInt(codigo_meio[3]))
        + String.fromCharCode(parseInt(codigo_meio[8]%2===0? 97 : 67)+ parseInt(codigo_meio[4]))
        + String.fromCharCode(parseInt(codigo_meio[3]%2===0? 97 : 67)+ parseInt(codigo_meio[6]))
        + String.fromCharCode(parseInt(codigo_meio[6]%2===0? 97 : 67)+ parseInt(codigo_meio[2]))
        + String.fromCharCode(parseInt(codigo_meio[3]%2===0? 97 : 67)+ parseInt(codigo_meio[11]))
        + String.fromCharCode(parseInt(codigo_meio[8]%2===0? 97 : 67)+ parseInt(codigo_meio[9]))

        return codigo_arquivo+'.pdf';
      }


      let cands =[
  {
    "num_cand": "U2FsdGVkX1+N3hG4+Hf1RiTc3DngTiuphQdpvOWCbCM=",
    "cpf": "U2FsdGVkX1+SNAxpj0CuaQgvIAa1yM9mUP9Dh7ubvcM="
  },
  {
    "num_cand": "U2FsdGVkX1/IERYFnsMVtwjK1CKKXFlAjMzlUQqIY60=",
    "cpf": "U2FsdGVkX19dYhfOu4ZlyqYym17Q3Z309DLzgr34Qp8="
  },
  {
    "num_cand": "U2FsdGVkX1+rPJIsedrQEFpidIu1p5iwQYnysq5p5Ts=",
    "cpf": "U2FsdGVkX1+dpnSzTNtdK6FvO3b2/+mTe+juHGV+BoU="
  },
  {
    "num_cand": "U2FsdGVkX1/WcTB6hue/FEwzeuzbzQO35fjh+dTeksY=",
    "cpf": "U2FsdGVkX199suWXrS/cg3ZtMhr/myBtQYOTBY7g3yI="
  },
  {
    "num_cand": "U2FsdGVkX18PPTfffWL1jXlX0f1FtlfsN4ZDAz0jO98=",
    "cpf": "U2FsdGVkX1+rta6CrETu4h+bnSK0o6kS8ha2T57Rwzk="
  },
  {
    "num_cand": "U2FsdGVkX1+4jbUZQLbEYJV60dNGUN4adF/e+tWTRes=",
    "cpf": "U2FsdGVkX1+bJQycx+aaHPQQDwfzvOpc9ogKZWd9RSE="
  },
  {
    "num_cand": "U2FsdGVkX18L5fZWqI6WwMzaew6p/Ba4Xwl+09oVxTA=",
    "cpf": "U2FsdGVkX1/3qx5OzLWyZFyIw2yEBvAec3BMggUtVhE="
  },
  {
    "num_cand": "U2FsdGVkX185GdUdpTm9eP4E/DJNjVlb/BA6LARRGSo=",
    "cpf": "U2FsdGVkX1+Dve0retx2qRFQUqfk+SCRR5aAPWcYVGE="
  },
  {
    "num_cand": "U2FsdGVkX196Zs9xNWaTOzRZyKa91ubrU5rjwxGowB0=",
    "cpf": "U2FsdGVkX1897tLBAknsjPq+m9kahlb23irgiAtWlz8="
  },
  {
    "num_cand": "U2FsdGVkX1+P++KLP7GzkJQHTROT8JsNttvSC9YBuKU=",
    "cpf": "U2FsdGVkX199GcZ0kLDF1vWFk/xET9WX9fIhMDA1wMY="
  },
  {
    "num_cand": "U2FsdGVkX1/aAPZ2vBrvYbgnkNW2Iw7ivsPFbBfj+p4=",
    "cpf": "U2FsdGVkX1+SoNpGtUrmbpGdkU5Gis4o9z35X5VSbkc="
  },
  {
    "num_cand": "U2FsdGVkX18Zd98v8UL8QJkpqU0xxlfBZS2kYatndZA=",
    "cpf": "U2FsdGVkX1+09JZrgt4mzkR7maMEXfFUH/nunzrmocg="
  },
  {
    "num_cand": "U2FsdGVkX19H5Iobt7jeZWwiM/beL45hd1fNCfPahH4=",
    "cpf": "U2FsdGVkX19oMK2Ab0bvGOK3DZw/O/6SXOOJBMSUyOI="
  },
  {
    "num_cand": "U2FsdGVkX1+VK4RABhwwcRebfCH07ZuSMONRAsZxGqU=",
    "cpf": "U2FsdGVkX1/jCdAJC4UFS1DDGRm88Sa6Jd/dO6ScAAk="
  },
  {
    "num_cand": "U2FsdGVkX1/pLTt8JRV1MXjZFO01HuG/dcJhFijsm5w=",
    "cpf": "U2FsdGVkX1/CICwmNhU0H5Cc2zzxeWJovOVTdWz341s="
  },
  {
    "num_cand": "U2FsdGVkX19JiXsT9MREe0ryxP9YyGU9rSEKt0l7+uU=",
    "cpf": "U2FsdGVkX1/bT56XtRjvv/YzE68oiAr9ErrTbQtpE08="
  },
  {
    "num_cand": "U2FsdGVkX18DaKbd2+3CXmn3dbFUcQsfX91a8WDbGzg=",
    "cpf": "U2FsdGVkX1+hrQqyreN5J9/b7gv2DJY1Ms91YRab0Qc="
  },
  {
    "num_cand": "U2FsdGVkX18KA78kIazz68ZqIAF7uIkvJHZIeis8iQM=",
    "cpf": "U2FsdGVkX181lEtmE1tFYEPi8IAmR7TpnYHcuH83pYU="
  },
  {
    "num_cand": "U2FsdGVkX18KO/ke0BEZ8CF83vzE9e8YTlFkZ7oCgqE=",
    "cpf": "U2FsdGVkX1+xT6/1rSJHjPwUz4uahuU3PlXNS5h50Io="
  },
  {
    "num_cand": "U2FsdGVkX18taCemGujWUeS0gE+gkKAnRd8AJUOsMjI=",
    "cpf": "U2FsdGVkX19NEUNgDvzlSrhPwb0Jnxj1dX/H9fq/ylI="
  },
  {
    "num_cand": "U2FsdGVkX1/cErS69KulzUacinZgFthz6yDqb+q6fUI=",
    "cpf": "U2FsdGVkX19XnFhdNEZEP6R4ge0AHsvpCVtN6wXLhYA="
  },
  {
    "num_cand": "U2FsdGVkX1+hYv4GFh8HPdBPJYB1DC/lKv70fJy+1Bw=",
    "cpf": "U2FsdGVkX1+DqMfAcnaMmG/hPcTUwUBhlVG18gqkPn4="
  },
  {
    "num_cand": "U2FsdGVkX186H6x9P2FANJjczQcpx1GQktT00cai8xw=",
    "cpf": "U2FsdGVkX18IE+1pIAXGQM8otRJvKLaPxquOL2W9S3k="
  },
  {
    "num_cand": "U2FsdGVkX19HpnnCM5cVgpurWPeLFiPtEOPegy8blo4=",
    "cpf": "U2FsdGVkX19pcjI7IMx4RsudJBOgRALyGiCGvOWhrNY="
  },
  {
    "num_cand": "U2FsdGVkX1/I4j2Zx5uFgrumy9+03hT1RS7d13uc3wU=",
    "cpf": "U2FsdGVkX189xW2hAyFse1kT9bF8XzL7QwgCfudGs8Q="
  },
  {
    "num_cand": "U2FsdGVkX1+IQEJUiQTfXyK8qirCtNytHoxqgUb12Tk=",
    "cpf": "U2FsdGVkX19448T/Fc5wzPy3q+P3LpIlMTrvY0Br33o="
  },
  {
    "num_cand": "U2FsdGVkX1+pPj6UPGmm2GK0QRmtRVOPU1IQlwrPA0Y=",
    "cpf": "U2FsdGVkX193IobMmTZKGmKmkPOcIymWR4FfIis3kTs="
  },
  {
    "num_cand": "U2FsdGVkX1+YK8htFzwy168YqwhXiwXMN0XCOGAgYg8=",
    "cpf": "U2FsdGVkX18X1E/VvGupGBXN14yLxJMI1cSUj1ZRrak="
  },
  {
    "num_cand": "U2FsdGVkX19ecJfpO73mfOpZCyxoX0FcyHhJmQ4YHlQ=",
    "cpf": "U2FsdGVkX1+41VbhBtLK+uQLLEWWHNNdJvf5v9RcVKM="
  },
  {
    "num_cand": "U2FsdGVkX1+iuMlDxx77paKH0XAdUar4NVgz5/cigx8=",
    "cpf": "U2FsdGVkX1+91bfKdyPUCW8BhdpYaVIA21xeKLHg9zw="
  },
  {
    "num_cand": "U2FsdGVkX19u2+OJ1E9MQNk9XdXil/kq3+QD6VtiJRE=",
    "cpf": "U2FsdGVkX1/yQdPD93Jd6Z+PDOj6QRxf4TWJPkXdsUE="
  },
  {
    "num_cand": "U2FsdGVkX1+f2t7r6GHzl82wfBxnQLsZvN1qEHCqf54=",
    "cpf": "U2FsdGVkX19Zb2c7kOC16Flz2w7R8fBIbEDtX/s1ZHg="
  },
  {
    "num_cand": "U2FsdGVkX1+r+VdoPxEfGHGjdGWaz2i1sHnPhTmRaRQ=",
    "cpf": "U2FsdGVkX191GWPnTD/95MDB5hAE6YJOfVY+zFa2S4o="
  },
  {
    "num_cand": "U2FsdGVkX1/G1n12hGYnQThZqDh4PR80ZwYWGwoYIo0=",
    "cpf": "U2FsdGVkX18Z0MfuhQxgr22aEFZzecyNCBPNDlgD5tc="
  },
  {
    "num_cand": "U2FsdGVkX197sYakE4e9H+sT8kz1be4XWLH4CdA/qCA=",
    "cpf": "U2FsdGVkX1+gjX92y0iLC4RKA4oRBLaUTU/FSYJccHg="
  },
  {
    "num_cand": "U2FsdGVkX1/KZO4MyWNFPktXjeONOuXv+g5XAEFiLeE=",
    "cpf": "U2FsdGVkX1+z5OTk7CyFLLOZcZQN8HFwGPqRzG5PmJI="
  },
  {
    "num_cand": "U2FsdGVkX1+BsI5LyqV1oPmHrvaEd8l+mqoFag2fcAU=",
    "cpf": "U2FsdGVkX18OKDKHY22BpLgeZigBXuzxdvCfrRAD210="
  },
  {
    "num_cand": "U2FsdGVkX1+P1j9ZhU8y59tppL5vzLQKnSicGX5A2a4=",
    "cpf": "U2FsdGVkX1/F4XwgJb6lYe+8Nu9exyryRzpfJtkId5k="
  },
  {
    "num_cand": "U2FsdGVkX18m1fWVIhSkxkHUYvVlsYPBpmn3LS2r5RM=",
    "cpf": "U2FsdGVkX1+gsyt3cNEDLgbTTeNVunIkGyD9YCekqIk="
  },
  {
    "num_cand": "U2FsdGVkX1/E5ZDkRvjc6TBeeRi6bTK4wP9FJyZYnCU=",
    "cpf": "U2FsdGVkX19fXGthHDJvfOKO8yxXw3k0ZYDTAVorAr0="
  },
  {
    "num_cand": "U2FsdGVkX185jl38rnn6A8vGDm2m3jlvosTiQzs7FcA=",
    "cpf": "U2FsdGVkX196qBnYMKI5Y4Zn2O8lZ1TI1quAhVwZfes="
  },
  {
    "num_cand": "U2FsdGVkX1/3fiD218QrmQNGAdnOJYAQKc2pAMKurYA=",
    "cpf": "U2FsdGVkX19WwSyimWOZg9rWykj+iODuCVffzCQ0RJY="
  },
  {
    "num_cand": "U2FsdGVkX1/fnGtTqOPVh9oW659NDyriLoHoBFlqLdE=",
    "cpf": "U2FsdGVkX1/O9u0/t+KsFAsSPmME7lWvUh4r0LqA4tY="
  },
  {
    "num_cand": "U2FsdGVkX18iKPNfUM7Koo56msDd39w7Ndw2ZgUU3WY=",
    "cpf": "U2FsdGVkX1+nxd6WjSsdoFb2SbS0/xxIyarLlgJJ+d8="
  },
  {
    "num_cand": "U2FsdGVkX1/2GpBq5b6LI/PqorvGHRvuj9aJlB2nbUA=",
    "cpf": "U2FsdGVkX18vSZsxkKz6GnVWYQ5OZ8zn48MUltZzUX4="
  },
  {
    "num_cand": "U2FsdGVkX18D3Ce36+BEp6wZw4qCa6Nr8pl3e2PIPYY=",
    "cpf": "U2FsdGVkX190HXS9jNnQWCpEHxGYfykjm2kyItYgkt0="
  },
  {
    "num_cand": "U2FsdGVkX18MI68UGRSpoGauLpgmdqoquRao9+Zj6g8=",
    "cpf": "U2FsdGVkX1/UB5Z2t9jH4bPmN9UAhF3Lb4MfausGWTA="
  },
  {
    "num_cand": "U2FsdGVkX1/i/0jnsI9qs+YxrYxeqNiwiZfjawGd+Hs=",
    "cpf": "U2FsdGVkX1841b/OM043DEaER3jqRnv+4BWMAe+khvM="
  },
  {
    "num_cand": "U2FsdGVkX1/jDaMNan4vcIJCB00/03drFd7upewpZPU=",
    "cpf": "U2FsdGVkX1+6fCYMBKQfuDsghMBjjoM7DbjKTju1/TQ="
  },
  {
    "num_cand": "U2FsdGVkX19e8p6+8nnggAR1n3MH7DEDcKFJWbX1jmQ=",
    "cpf": "U2FsdGVkX18KdcsxEhozd3iv/Gu+BejRVJfQQXHvOzo="
  },
  {
    "num_cand": "U2FsdGVkX18wtZFuNMyNhi67Gf/zbSVId2J1WuweTyE=",
    "cpf": "U2FsdGVkX1/kSfu5l3MzCzkD09SuSekRE1b9DRvb8FU="
  },
  {
    "num_cand": "U2FsdGVkX19tgTXCZvv2kOnIJHoZc4z3rcJ4B8y6pk0=",
    "cpf": "U2FsdGVkX19q2p9mAoJSyZrAIf43wf0U6OBrsknHQ5E="
  },
  {
    "num_cand": "U2FsdGVkX1/j1VJDe98EtHzyr7ZA+8iNPXjVVZdLvQM=",
    "cpf": "U2FsdGVkX1/RaPxqf+9pcR8KF0h84uD/8dqL91KZ8M4="
  },
  {
    "num_cand": "U2FsdGVkX1/RWJZPvIeb/ItJlb7fDVIVbd75wqaCBmE=",
    "cpf": "U2FsdGVkX18De0X2xOEp5EqcGh4r0jHbrVu29vhPv30="
  },
  {
    "num_cand": "U2FsdGVkX1+4EwL0ZjrvsTrSmeD2BBeFicuLEcumGQM=",
    "cpf": "U2FsdGVkX1+XVrg2srlgvJgKEoUqZF+7GQDqYzibBEY="
  },
  {
    "num_cand": "U2FsdGVkX18b2weyqOcIlplcZe6zYDHczNd3emiG/o4=",
    "cpf": "U2FsdGVkX1/DYRH/mN5+nSxqU/nhZgpP+G3fNl2W06w="
  },
  {
    "num_cand": "U2FsdGVkX1/uTLqIVvhMz/oq+wYVbQSA0ciU2lGSj1w=",
    "cpf": "U2FsdGVkX19y7qcJ2YJiNxMVVGdwYI5u2UKNV3U1mug="
  },
  {
    "num_cand": "U2FsdGVkX19TO57jUMlUFSBvHrPDRziRVauhsfesJLc=",
    "cpf": "U2FsdGVkX1+/3Oefx0svUVId9wy5s9YNuPJ78Pd8Yyg="
  }
]


      try {
        let concurso = this.$route.params.concurso;
        localStorage.setItem('concurso', concurso);

        for (let login of cands) {
            let num_cand_decripted = decrypt(login.num_cand);
            let cpf_decripted = decrypt(login.cpf);

            // console.log(num_cand_decripted,cpf_decripted)
          if (num_cand_decripted == this.username && cpf_decripted == this.password) {
            console.log(`Logged`)
             let nome_arquivo = (gera_file_name(cpf_decripted,num_cand_decripted))


            // alert(`Logou`);
              let url = (`https://fs.ibfc.org.br/arquivos/2112/2112_rec_gabx/${nome_arquivo}`)
            return window.location.replace(url);
          }
        }

        throw new Error(`Login inválido`);


      } catch (error) {
        console.log(error);
        this.login_errado = true;
      }
    }
  }
};
</script>
<style>
</style>
